import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Users, LayoutTemplate, Sparkles, Eye, Send } from "lucide-react";

const STEPS = [
  { icon: Users, title: "1 · Gruppe & Empfänger", text: "Lege eine Gruppe an und importiere Empfänger (Outlook .msg) oder füge sie manuell hinzu. Pflege Anrede/Vorname für persönliche Ansprache und markiere wichtige Leads mit dem Stern." },
  { icon: LayoutTemplate, title: "2 · Vorlage wählen oder gestalten", text: "Wähle eine Vorlage aus der Galerie oder baue die Mail im Editor aus Bausteinen (Text, Überschrift, Bild, Button). Platzhalter wie {{Anrede}} werden pro Empfänger ersetzt." },
  { icon: Sparkles, title: "3 · KI nutzen (optional)", text: "Lass die KI einen Textentwurf schreiben, den Tonfall anpassen oder die Rechtschreibung prüfen. Erzeuge passende Bilder im Brand- oder Kreativ-Modus." },
  { icon: Eye, title: "4 · Vorschau & Qualitäts-Check", text: "Prüfe die Mail in der Desktop- und Mobil-Vorschau. Der Qualitäts-Check testet Links und Platzhalter. Sende dir zur Sicherheit eine Testmail." },
  { icon: Send, title: "5 · Senden & auswerten", text: "Versende die Rundmail personalisiert an alle Empfänger. Im Kampagnen-Dashboard siehst du Öffnungs- und Klickraten – und wirst benachrichtigt, wenn ein wichtiger Lead öffnet." },
];

export const MailingGuideDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="mailing-guide-dialog">
      <DialogHeader>
        <DialogTitle>Kurzanleitung: In 5 Schritten zur Rundmail</DialogTitle>
        <DialogDescription>So versendest du in wenigen Minuten eine perfekt gebrandete E-Mail.</DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-1">
        {STEPS.map((s, i) => (
          <div key={i} className="flex gap-3 rounded-lg border p-3" data-testid={`guide-step-${i + 1}`}>
            <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <s.icon className="w-4.5 h-4.5 text-primary" />
            </div>
            <div>
              <div className="font-medium text-sm">{s.title}</div>
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{s.text}</p>
            </div>
          </div>
        ))}
      </div>
      <DialogFooter>
        <Button type="button" onClick={() => onOpenChange(false)} data-testid="guide-close-btn">Verstanden</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
